
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetKey } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  private data: any = {};
  private tab1: any = "既往史";
  private tab2: any = "家族史";
  private tab3: any = "生活方式";
  private keyVal(val: any) {
    return GetKey(val);
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private goEditPatient() {
    this.$router.push({
      path: "/main/manage/patient",
      query: {
        patient_id: this.patient.patient_id,
      },
    });
  }
}
